import React, { useRef, useState, useEffect } from "react";

const SearchableDropdown = ({
  options,
  def,
  name,
  label,
  onInputChange,
  required,
}) => {
  const [search, setSearch] = useState(def || "");
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedValue, setSelectedValue] = useState(def || "");
  const containerRef = useRef(null);

  useEffect(() => {
    if (def) onInputChange({ target: { name: name, value: def } });
  }, [def]);

  const filteredOptions = options.filter(
    (option) =>
      option.toLowerCase().includes(search.toLowerCase()) && option !== "N/A"
  );

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => setSelectedValue(def), [def]);

  const handleSelect = (option) => {
    setSearch(option);
    setSelectedValue(option);
    setShowDropdown(false);
    if (onInputChange) {
      onInputChange({ target: { name, value: option } });
    }
  };

  return (
    <div ref={containerRef} className="form-input">
      <input
        type="text"
        placeholder={`Search ${label}...`}
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          setShowDropdown(true);
        }}
        onFocus={() => setShowDropdown(true)}
        style={{ border: "none", width: "100%", height: "100%" }}
        required={required && !selectedValue}
      />

      {showDropdown && filteredOptions.length > 0 && (
        <ul
          style={{
            listStyle: "none",
            // margin: "10px",
            padding: 0,
            border: "1px solid black",
            borderTop: "none",
            borderRadius: "0 0 4px 4px",
            maxHeight: "150px",
            overflowY: "auto",
            position: "relative",
            // top: "110%",
            // left: 0,
            width: "100%",
            backgroundColor: "white",
            zIndex: 1000,
          }}
        >
          {filteredOptions.map((option) => (
            <li
              key={option}
              onClick={() => handleSelect(option)}
              style={{
                padding: "10px",
                cursor: "pointer",
                borderBottom: "1px solid var(--color-border)",
                fontSize: "16px",
              }}
              onMouseDown={(e) => e.preventDefault()} // prevent blur
            >
              {option}
            </li>
          ))}
        </ul>
      )}

      {/* Hidden native select for form submission */}
      <select
        name={name}
        value={selectedValue}
        onChange={onInputChange}
        style={{ display: "none" }}
      >
        <option value="">Select {label}</option>
        {options
          .filter((opt) => opt !== "N/A")
          .map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
      </select>
    </div>
  );
};

export default SearchableDropdown;
